module.exports = __webpack_public_path__ + "static/img/report_bg4.cf30ed89.png";